import { Box, Typography } from '@mui/material';
import * as R from 'ramda';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { EpisodeGrid } from '@/containers';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectUserAudienceRegions,
  selectUserCompliance,
  useFetchEpisodesQuery,
  useFetchRelatedEpisodesQuery,
} from '@/store';
import { Episode, Referrer } from '@/types';

export const RelatedEpisodes = ({
  episode,
  referrer,
}: {
  episode: Episode;
  referrer: Referrer;
}) => {
  const compliance = useSelector(selectUserCompliance);
  const audienceRegions = useSelector(selectUserAudienceRegions);

  const { data: relatedEpisodesV2 } = useFetchRelatedEpisodesQuery({
    episodeId: episode.episodeId,
    compliance,
    audienceRegions,
  });

  const relatedEpisodeIds = useMemo(
    () =>
      R.pipe(
        R.uniq,
        R.slice(0, 6),
      )([
        ...(relatedEpisodesV2?.map(e => e.episodeId) || []),
        ...(episode.relatedEpisodes || []),
      ]) as string[],
    [episode.relatedEpisodes, relatedEpisodesV2],
  );

  const { data: relatedEpisodes } = useFetchEpisodesQuery(
    {
      episodeIds: relatedEpisodeIds,
      compliance,
    },
    {
      skip: !relatedEpisodeIds?.length,
    },
  );

  if (!relatedEpisodes?.length) return null;

  return (
    <Box>
      <Typography variant="h3">Related Episodes</Typography>
      <EpisodeGrid
        episodes={relatedEpisodes}
        referrer={{
          ...referrer,
          section: EVENT_CONSTANTS.SECTION.RELATED_EPISODES,
        }}
      />
    </Box>
  );
};
